<template>
  <div>
    <a-drawer
        v-model:visible="feedShow"
        :bodyStyle="{ padding: 0 }"
        :closable="false"
        class="drawer"
        placement="right"
        style="color: #000000"
        width="600"
    >
      <div class="header">
        <div class="title f-w-b f-16">
          意见与建议详情
        </div>
        <div
            v-if="detailsData.status == 1"
            class="bar"
            style="background-color: #009999"
        >
          {{ detailsData.status_text }}
        </div>
        <div
            v-else-if="detailsData.status == 2"
            class="bar"
            style="background-color: #0094ff"
        >
          {{ detailsData.status_text }}
        </div>
        <div
            v-else-if="detailsData.status == 3"
            class="bar"
            style="background-color: #ff9900"
        >
          {{ detailsData.status_text }}
        </div>
        <div
            v-else-if="detailsData.status == 4"
            class="bar"
            style="background-color: #333333"
        >
          {{ detailsData.status_text }}
        </div>
      </div>
      <div class="content">
        <!-- 基础信息 -->
        <div class="title f-w-b">基础信息</div>
        <div class="info">
          <div class="lef f-c-999">订单ID：</div>
          <div class="rig">
            {{ detailsData.order_id }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">订单号：</div>
          <div class="rig">{{ detailsData.order_no }}</div>
        </div>
        <div class="info">
          <div class="lef f-c-999">房间ID：</div>
          <div class="rig">
            {{ detailsData.hid }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">房间：</div>
          <div class="rig">
            {{ detailsData.hname }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">用户信息：</div>
          <div class="rig">
            {{ detailsData.nickname }} ({{ detailsData.user_id }})
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">联系方式：</div>
          <div class="rig">
            {{ detailsData.phone }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">解决方案：</div>
          <div class="rig">
            {{ detailsData.plan }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">反馈意见：</div>
          <div class="rig">
            {{ detailsData.feedback }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">提交时间：</div>
          <div class="rig">
            {{ detailsData.create_time }}
          </div>
        </div>
        <div v-if="detailsData.confirm_time" class="info">
          <div class="lef f-c-999">确认时间：</div>
          <div class="rig">
            {{ detailsData.confirm_time_text }}
          </div>
        </div>
        <div v-if="detailsData.solve_time" class="info">
          <div class="lef f-c-999">解决时间：</div>
          <div class="rig">
            {{ detailsData.solve_time_text }}
          </div>
        </div>
        <div v-if="detailsData.close_time" class="info">
          <div class="lef f-c-999">关闭时间：</div>
          <div class="rig">
            {{ detailsData.close_time_text }}
          </div>
        </div>
        <!-- 附件 -->
        <div v-if="images.length" class="title f-w-b">附件</div>
        <div class="info">
          <a-image
              v-for="(item, index) in images"
              :key="index"
              :src="imgCut(item.url, 'xl')"
              alt="房源图片"
              fit="fill"
              style="
              width: 80px;
              height: 50px;
              object-fit: cover;
              margin: 0 10px 10px 0;
            "
          />
        </div>

        <!-- 日志 -->
        <div
            class="info-cont"
            style="width: 100%; margin-bottom: 10px"
        >
          <a-table
              :columns="costColumns"
              :dataSource="logs"
              :pagination="false"
              size="small"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key == 'operate_id'">
                <span>{{ record.nickname }}({{ record.operate_id }})</span>
              </template>
            </template>
          </a-table>
        </div>
        <div style="height: 60px"></div>

        <!-- 操作 -->
        <div class="operate">
          <div v-if="detailsData.status == 1" class="lef">
            <a-button
                class="btn-primary"
                @click="handleEdit(detailsData.status,detailsData.id)"
            >去确认
            </a-button>
          </div>
          <div v-if="detailsData.status == 2" class="lef">
            <a-button
                class="btn-primary"
                @click="handleEdit(detailsData.status,detailsData.id)"
            >已解决
            </a-button>
          </div>
          <div v-if="detailsData.status == 3" class="lef">
            <a-button
                class="btn-primary"
                @click="handleEdit(detailsData.status,detailsData.id)"
            >去关闭
            </a-button>
          </div>
          <div class="rig">
            <a-button
                class="btn-info"
                @click="handleClose"
            >关闭
            </a-button
            >
          </div>
        </div>
      </div>
    </a-drawer>

  </div>
  <!-- 弹窗 -->
  <a-modal
      v-model:visible="visibleConfirm"
      :title="modalTitle"
      :width="600"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item v-if="detailsData.status == 2" label="解决方案：" name="plan">
        <a-textarea
            v-model:value="addForm.plan"
            :maxlength="255"
            placeholder="请输入解决方案" show-count
            style="width: 100%"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="备注说明：" name="remark">
        <a-textarea
            v-model:value="addForm.remark"
            :maxlength="255"
            placeholder="请输入处理备注信息" show-count
            style="width: 100%"
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import useUtils from "@/hooks/useUtils.js"; //工具库
import {feedBackDetails, feedBackOperate} from "@/api/api";
import {defineComponent, nextTick, reactive, toRefs, watch} from "vue";
import {message} from "ant-design-vue";
// import { message, Modal } from "ant-design-vue";
// import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  components: {},
  emits: ["update:visible", "refresh"],
  setup(props, {emit}) {
    let {imgCut} = useUtils();
    // 详情
    const details = reactive({
      feedShow: false,
      visibleAdd: false,
      id: "",
      modalTitle: "修改任务",
      addForm: {},
      images: [],
      logs: [],
      costColumns: [
        {
          title: "操作用户",
          dataIndex: "operate_id",
          key: "operate_id",
        },
        {
          title: "状态",
          key: "status_text",
          dataIndex: "status_text",
        },
        {
          title: "解决方案",
          dataIndex: "plan",
          ellipsis: true
        },
        {
          title: "备注",
          dataIndex: "remarks",
          ellipsis: true
        },
        {
          title: "时间",
          dataIndex: "create_time",
        },
      ],

      detailsData: {
        rela: [],
      },
      //  获取详情
      getTaskDetail() {
        details.feedShow = true;
        console.log(details)
        feedBackDetails({
          id: details.id,
        }).then((res) => {
          details.detailsData = res.data;
          details.images = res.data.images;
          details.logs = res.data.logs;
        });
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleConfirm: false,
      handleOpenModal() {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.visibleConfirm = true;
      },
      formRef: "", //表单验证
      addForm: {
        plan: "",
        remark: "",
        type: "",
        id: "",
      },
      rules: {
        plan: [
          {
            required: false,
            message: "请输入解决方案",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: false,
            message: "请输入备注信息",
            trigger: "blur",
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.isLoading = true;
          feedBackOperate(modal.addForm)
              .then((res) => {
                message.success(res.msg);
                nextTick(() => {
                  modal.isLoading = false;
                });
                modal.visibleConfirm = false;
                emit("refresh");
              })
              .catch(() => {
                modal.isLoading = false;
              });
        });
      },
      handleEdit(status, id) {
        this.addForm.id = id;
        if (status == 1) {
          modal.modalTitle = "确认意见";
          this.addForm.type = 1;
        } else if (status == 2) {
          modal.modalTitle = "解决意见";
          this.addForm.type = 2;
        } else if (status == 3) {
          modal.modalTitle = "关闭意见";
          this.addForm.type = 3;
        }
        modal.visibleConfirm = true;
      },
      handleClose() {
        details.feedShow = false;
        emit("refresh");
      },
    });


    watch(
        () => props.visible,
        (newValue) => {
          details.feedShow = newValue;
          if (newValue) {
            details.id = props.id;
            details.getTaskDetail();
          }
        }
    );

    watch(
        () => details.feedShow,
        (value) => {
          emit("update:visible", value);
        }
    );

    return {
      ...toRefs(details),
      ...toRefs(modal),
      imgCut,
    };
  },
});
</script>

<style lang="scss" scoped>
.task {
  background-color: #ffffff;
  margin-bottom: 5px;
  max-height: 200px;
  overflow-y: auto;

  .m-l-10 {
    margin-left: 5px;
  }

  .selTask {
    background-color: #0094ff11;
    // color: #FFFFFF !important;
  }

  .tasks-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #f7f7f7;
    padding: 0 20px;
    cursor: pointer;

    &:hover {
      background-color: #f2f2f2;
    }

    .tasks-lef {
      text-align: left;
      display: flex;
      align-items: center;
    }

    .tasks-rig {
    }
  }

  .bar {
    // border: 2rpx solid #999999;
    border-radius: 5px;
    padding: 1px 5px;
    background-color: #f2f2f2;
    color: #000000;
  }

  .status {
    border-radius: 15px;
    padding: 2px 5px;
    font-size: 12px;
  }
}

.drawer {
  // position: absolute;
  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .bar {
      border-radius: 10px;
      padding: 2px 10px;
      height: 20px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 12px;
    }

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
        text-align: right;
        padding-right: 15px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 550px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}
</style>
